module.exports = __webpack_public_path__ + "img/guide-cod-3.ad190c94.png";